<template>
  <user-center-wrap>
    <div class="checkin">
      <div class="title">
        <div class="bar"></div>
        <div class="text">每日签到</div>
      </div>
      <div class="desc">
        <div class="left">
          您已连续签到 <span>{{ continuous }}</span> 天
        </div>
        <div class="right" v-show="!isCheckedToday">今日未签到</div>
        <div class="right" v-show="isCheckedToday" style="color: #999999">今日已签到</div>
      </div>
      <div class="content">
        <div :class="['list', !isCheckedToday && index === continuous ? 'list-active' : '']" v-for="(item, index) in checkinList" :key="index">
          <div class="a">{{ item.ExpNum }}</div>
          <img class="b" :src="item.IsChecked ? require('./img/checked.png') : !isCheckedToday && index === continuous ? require('./img/checking.png') : require('./img/check.png')" alt="" />
          <div class="c">{{ whichDay[index] }}</div>
          <img class="d" v-if="item.RewardNum > 1" src="./img/gift.png" alt="" />
          <div class="e text-overflow" v-if="item.RewardNum === 1">
            {{ (item.RewardList[0].reward_type === 1 || item.RewardList[0].reward_type === 2 ? item.RewardList[0].quantity / 100 : item.RewardList[0].quantity) + item.RewardList[0].title }}
          </div>
        </div>
        <div :class="['list list-7', !isCheckedToday && continuous === 6 ? 'list-active' : '']">
          <div class="a"><span>经验值</span>{{ checkinLast.ExpNum }}</div>
          <img class="b" :src="checkinLast.IsChecked ? require('./img/checked.png') : !isCheckedToday && continuous === 6 ? require('./img/checking.png') : require('./img/check.png')" alt="" />
          <div class="c">第七天</div>
          <img class="d" v-if="checkinLast.RewardNum > 1" src="./img/gift.png" alt="" />
          <div class="e text-overflow" v-if="checkinLast.RewardNum === 1">
            {{
              (checkinLast.RewardList[0].reward_type === 1 || checkinLast.RewardList[0].reward_type === 2 ? checkinLast.RewardList[0].quantity / 100 : checkinLast.RewardList[0].quantity) +
              checkinLast.RewardList[0].title
            }}
          </div>
        </div>
        <div :class="['btn', !isCheckedToday ? 'btn-active' : '']" @click="checkin">立即签到</div>
      </div>
      <div class="title" style="margin-top: 0.32rem; margin-bottom: 0.16rem">
        <div class="bar"></div>
        <div class="text">签到记录</div>
      </div>
      <el-table
        border
        :data="tableData"
        :row-style="{ height: '56px', fontSize: '14px' }"
        :cell-style="{ padding: 0 }"
        :header-row-style="tableHeaderRow"
        :header-cell-style="tableHeaderColor"
        style="width: 100%"
      >
        <el-table-column prop="CheckinTime" min-width="30%" label="签到时间" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span style="cursor: pointer">{{ scope.row.CheckinTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="RewardDesc" label="领取记录" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div class="gift">
              <div class="gift-list" v-for="(item, index) in scope.row.RewardDesc" :key="index">
                <img :src="item.icon ? item.icon : checkinRewardPic(item.reward_type)" alt="" />
                <div>{{ item.title + "x" + (item.reward_type === 1 || item.reward_type === 2 ? item.quantity / 100 : item.quantity) }}</div>
              </div>
            </div>
          </template>
        </el-table-column>

        <div slot="empty" class="search_list">
          <div class="list_body">
            <div class="empty_content">
              <Empty text="暂时没有收入数据" :imgWidth="250" :img="require('@/assets/img/empty/no-data.png')"></Empty>
            </div>
          </div>
        </div>
      </el-table>
    </div>
    <Checkin ref="checkin" />
  </user-center-wrap>
</template>

<script>
import UserCenterWrap from "../../../components/user-center-wrap/user-center-wrap";
import { post } from "../../../util/http";
import { mapState, mapMutations, mapActions } from "vuex";
import Empty from "@/components/empty/empty";
import Checkin from "@/components/checkin/checkin.vue";
export default {
  name: "checkin",
  components: {
    UserCenterWrap,
    Empty,
    Checkin,
  },
  data() {
    return {
      tableData: [],
      checkinList: [],
      checkinLast: {},
      continuous: 0,
      // isActive: false,
      isCheckedToday: false,
      whichDay: ["第一天", "第二天", "第三天", "第四天", "第五天", "第六天"],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.getCheckinInfo();
    this.getCheckinHistory();
    // this.toggleCheckinDialog(true);
  },
  methods: {
    ...mapMutations(["toggleCheckinDialog"]),
    async getCheckinInfo() {
      const {
        data: { data },
      } = await post({
        url: "/api/checkin/getCheckinInfo",
      });
      this.checkinLast = data.CheckinDetails.pop();
      this.checkinList = data.CheckinDetails;
      this.continuous = data.Continuous;
      this.isCheckedToday = data.IsCheckedToday;
    },
    async getCheckinHistory() {
      const {
        data: { data },
      } = await post({
        url: "/api/checkin/getCheckinHistory",
      });
      this.tableData = data.CheckinHistory;
    },
    async checkin() {
      if (!this.userInfo.id) return;
      if (this.isCheckedToday) {
        this.$message.error("今天已签到");
        return;
      }
      const { data } = await post({
        url: "/api/checkin/checkinToday",
      });
      if (data.status === 0) {
        localStorage.setItem("checkinGift", JSON.stringify(data.data.RewardList));
        this.$message.success("签到成功");
        // this.toggleCheckinDialog(true);
        this.getCheckinInfo();
        this.getCheckinHistory();
      } else {
        this.$message.error("签到失败");
      }
    },
    // 设置表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return `
				background-color:#02A8A2;
				color:#ffffff;
				font-size: 14px;
				font-weight:500;
				height: 36px;
				padding: 0px";
				border : 0px;
			 `;
    },
    tableHeaderRow() {
      return `
				height:56px;
				letter-spacing:1px;
				border-radius : 20px;
			`;
    },
    handleSizeChange(val) {
      this.currentPage = val;
      this.selectList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getListInfo();
    },
    checkinRewardPic(type) {
      switch (type) {
        case 0:
          return require("@/assets/img/checkin/exp.png");
        case 1:
          return require("@/assets/img/checkin/falcon-coin.png");
        case 2:
          return require("@/assets/img/checkin/diamond.png");
        case 3:
          return require("@/assets/img/checkin/gift-live.png");
        case 4:
          return require("@/assets/img/checkin/card.png");
        case 5:
          return require("@/assets/img/checkin/prop.png");
        case 6:
          return require("@/assets/img/checkin/lucky.png");

        default:
          return require("@/assets/img/default/default_logo.png");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.checkin {
  width: 100%;
  height: 100%;
  padding: 0.28rem 0.44rem;
}
.title {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 500;
  font-size: 0.2rem;
  color: #333333;
  display: flex;
  align-items: center;
  .bar {
    width: 0.04rem;
    height: 0.16rem;
    background: #02a8a2;
    margin-right: 0.1rem;
  }
}
.desc {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 0.42rem;
  .left {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 600;
    font-size: 0.24rem;
    display: flex;
    align-items: flex-end;
    color: #333333;
    span {
      font-weight: 700;
      font-size: 0.48rem;
      display: flex;
      color: #ff9018;
      margin: 0 0.1rem;
      line-height: 0.36rem;
    }
  }
  .right {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 0.16rem;
    color: #02a8a2;
  }
}
.content {
  margin-top: 0.2rem;
  padding: 0.15rem;
  height: 1.1rem;
  border: 0.01rem solid #f9f9fb;
  border-radius: 0.06rem;
  display: flex;
  align-items: center;
  .list {
    background: #f4f4f4;
    border-radius: 0.05rem;
    width: 0.72rem;
    height: 0.8rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding-top: 0.08rem;
    padding-bottom: 0.04rem;
    margin-right: 0.08rem;
    position: relative;
    cursor: pointer;
    .a {
      font-size: 0.2rem;
      color: #333333;
      font-weight: 700;
    }
    .b {
      width: 0.28rem;
    }
    .c {
      font-size: 0.14rem;
      color: #999999;
    }
    .d {
      width: 0.28rem;
      position: absolute;
      top: -0.1rem;
      right: -0.05rem;
    }
    .e {
      transform: scale(0.8);
      width: 0.6rem;
      height: 0.2rem;
      padding: 0 0.1rem;
      background: linear-gradient(136.27deg, #ffd600 20%, #ff8f00 95.56%);
      border-radius: 0.16rem 0;
      position: absolute;
      top: -0.12rem;
      right: -0.05rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 0.12rem;
    }
  }
  .list-active {
    background: linear-gradient(340.94deg, #03a2fa 18.8%, #8dffd1 110.43%);
    .a {
      color: #ffffff;
    }
    .c {
      color: #ffffff;
    }
  }
  .list-7 {
    width: 1.36rem;
    padding: 0.17rem 0.1rem 0.12rem;
    align-items: flex-start;
    .a {
      span {
        font-weight: 400;
        font-size: 0.16rem;
        color: #666666;
      }
    }
    .b {
      width: 0.4rem;
      position: absolute;
      right: 0.05rem;
      bottom: 0.08rem;
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.1rem;
    height: 0.46rem;
    background: linear-gradient(108.02deg, #e2e4e4 0%, #d3d6da 62.15%);
    border-radius: 0.05rem;
    margin-left: 0.16rem;
    font-weight: 600;
    font-size: 0.16rem;
    color: #ffffff;
  }
  .btn-active {
    background: linear-gradient(136.27deg, #ffd600 20%, #ff8f00 95.56%);
    cursor: pointer;
  }
}
.el-table {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
::v-deep .el-pagination {
  text-align: center;
  margin-top: 0.16rem;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #02a8a2;
}
.gift {
  display: flex;
  justify-content: center;
  color: #999999;
  font-size: 0.12rem;
  .gift-list {
    display: flex;
    align-items: center;
    margin-right: 0.15rem;
    img {
      height: 0.24rem;
      margin-right: 0.03rem;
    }
  }
}
</style>
